import { useQuery } from '@tanstack/react-query';
import { moodleQueryKeys } from '../all-query-keys';
import { getMoodleCourses } from '../../../services/MoodleService';

export const useGetMoodleCourses = () => {
  const { data, isLoading } = useQuery({
    queryKey: moodleQueryKeys.getMoodleCourses(),
    queryFn: getMoodleCourses,
  });

  const courses = data?.data || [];
  return { courses, loading: isLoading };
};
